(() => {
  const MENU_SELECTOR = '[data-flyout-menu]';
  const ITEM_SELECTOR = '[data-flyout-item]';
  const ENGLISH_MENU_SELECTORS = [
    '.header__linklist',
    '.nav-dropdown',
    '.mega-menu-flyout__list',
    '.linklist',
    '.mobile-nav',
    '.sidebar-menu__list',
    '.sidebar-menu__dropdown-list'
  ];

  function isEnglishLocale() {
    const locale = (document.documentElement.lang || (window.Shopify && window.Shopify.locale) || '').toLowerCase();

    return /^en(?:-|$)/.test(locale);
  }

  function sortListItems(list) {
    const items = Array.from(list.children).filter(child => child.tagName === 'LI');

    if (items.length < 2) {
      return;
    }

    const collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: 'base'
    });

    items
      .map((item, index) => ({
        item,
        index,
        text: item.textContent.replace(/\s+/g, ' ').trim()
      }))
      .sort((left, right) => {
        const comparison = collator.compare(left.text, right.text);

        return comparison !== 0 ? comparison : left.index - right.index;
      })
      .forEach(({ item }) => {
        list.appendChild(item);
      });
  }

  function sortEnglishMenus(root = document) {
    if (!isEnglishLocale()) {
      return;
    }

    ENGLISH_MENU_SELECTORS.forEach(selector => {
      root.querySelectorAll(selector).forEach(sortListItems);
      });
  }

  function disableImageContextMenu(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    if (!event.target.closest('img')) {
      return;
    }

    event.preventDefault();
  }

  function firstChildId(menu, rootId) {
    const panel = menu.querySelector(`[data-flyout-panel][data-flyout-level="2"][data-flyout-parent="${rootId}"]`);

    if (!panel) {
      return '';
    }

    const firstChild = panel.querySelector('[data-flyout-level="2"]');

    return firstChild ? firstChild.dataset.flyoutId || '' : '';
  }

  function updateFlyout(menu, rootId, childId) {
    menu.dataset.flyoutRootId = rootId;
    menu.dataset.flyoutChildId = childId;

    menu.querySelectorAll('[data-flyout-level="1"]').forEach(item => {
      item.classList.toggle('is-active', item.dataset.flyoutId === rootId);
    });

    menu.querySelectorAll('[data-flyout-level="2"]').forEach(item => {
      item.classList.toggle('is-active', item.dataset.flyoutId === childId);
    });

    menu.querySelectorAll('[data-flyout-panel][data-flyout-level="2"]').forEach(panel => {
      panel.hidden = panel.dataset.flyoutParent !== rootId;
    });

    menu.querySelectorAll('[data-flyout-panel][data-flyout-level="3"]').forEach(panel => {
      panel.hidden = panel.dataset.flyoutParent !== childId;
    });
  }

  function animateFlyoutPanel(panel, delayOffset = 0) {
    if (!panel || panel.hidden || MediaFeatures.prefersReducedMotion()) {
      return;
    }

    const items = Array.from(panel.querySelectorAll('.mega-menu-flyout__link'));

    items.forEach(item => {
      item.getAnimations().forEach(animation => animation.cancel());
      item.style.opacity = 0;
    });

    new CustomAnimation(new ParallelEffect(items.map((item, index) => new CustomKeyframeEffect(item, {
      opacity: [0, 1],
      transform: ['translateY(20px)', 'translateY(0)']
    }, {
      duration: 250,
      delay: delayOffset + 100 + 60 * index,
      easing: 'cubic-bezier(0.65, 0, 0.35, 1)'
    })))).play();
  }

  function activateItem(item) {
    const menu = item.closest(MENU_SELECTOR);

    if (!menu) {
      return;
    }

    const level = item.dataset.flyoutLevel;

    if (level === '1') {
      const rootId = item.dataset.flyoutId || '';
      const currentRootId = menu.dataset.flyoutRootId || '';
      const currentChildId = menu.dataset.flyoutChildId || '';
      const nextChildId = firstChildId(menu, rootId);

      if (currentRootId === rootId && currentChildId === nextChildId) {
        return;
      }

      updateFlyout(menu, rootId, nextChildId);

      const rootPanel = menu.querySelector(`[data-flyout-panel][data-flyout-level="2"][data-flyout-parent="${rootId}"]`);
      animateFlyoutPanel(rootPanel);
    } else if (level === '2') {
      const rootId = item.dataset.flyoutParent || '';
      const childId = item.dataset.flyoutId || '';
      const currentRootId = menu.dataset.flyoutRootId || '';
      const currentChildId = menu.dataset.flyoutChildId || '';

      if (currentRootId === rootId && currentChildId === childId) {
        return;
      }

      updateFlyout(menu, rootId, childId);
      animateFlyoutPanel(menu.querySelector(`[data-flyout-panel][data-flyout-level="3"][data-flyout-parent="${childId}"]`), 40);
    }
  }

  function shouldActivateItem(event, item) {
    const relatedTarget = event.relatedTarget;

    return !(relatedTarget instanceof Node) || !item.contains(relatedTarget);
  }

  function initializeMenu(menu) {
    if (menu.dataset.flyoutInitialized === 'true') {
      return;
    }

    menu.dataset.flyoutInitialized = 'true';

    const rootPanels = Array.from(menu.querySelectorAll('[data-flyout-panel][data-flyout-level="2"]'));
    let rootId = '';
    let childId = '';

    for (const panel of rootPanels) {
      const candidateRootId = panel.dataset.flyoutParent || '';
      const candidateChild = panel.querySelector('[data-flyout-level="2"]');

      if (candidateChild) {
        rootId = candidateRootId;
        childId = candidateChild.dataset.flyoutId || '';
        break;
      }

      if (!rootId) {
        rootId = candidateRootId;
      }
    }

    if (rootId) {
      updateFlyout(menu, rootId, childId || firstChildId(menu, rootId));

      animateFlyoutPanel(menu.querySelector(`[data-flyout-panel][data-flyout-level="2"][data-flyout-parent="${rootId}"]`));
    }
  }

  function initializeAll(root = document) {
    root.querySelectorAll(MENU_SELECTOR).forEach(initializeMenu);
  }

  function hoistHomepageSlideshow(root = document) {
    if (document.body.dataset.pageType !== 'index') {
      return;
    }

    const mainInner = root.querySelector('#main-inner');

    if (!mainInner) {
      return;
    }

    const slideshow = Array.from(mainInner.children).find(child => child.matches('.shopify-section--slideshow'));

    if (!slideshow || slideshow.parentNode !== mainInner) {
      return;
    }

    mainInner.parentNode.insertBefore(slideshow, mainInner);
  }

  function getDescriptionWrapper(toggle) {
    return toggle.closest('[data-collection-description-wrapper], [data-product-description-wrapper]');
  }

  function updateDescriptionToggle(toggle) {
    const wrapper = getDescriptionWrapper(toggle);
    const details = wrapper ? wrapper.querySelector('details') : null;

    if (!details) {
      return;
    }

    toggle.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function updateDescriptionToggles(details) {
    if (!(details instanceof Element)) {
      return;
    }

    const wrapper = details.closest('[data-collection-description-wrapper], [data-product-description-wrapper]');

    if (!wrapper) {
      return;
    }

    wrapper.querySelectorAll('[data-collection-description-toggle], [data-product-description-toggle]').forEach(updateDescriptionToggle);
  }

  function normalizeDescriptionContent(content) {
    if (!(content instanceof Element) || content.dataset.productDescriptionNormalize !== 'true' || content.dataset.descriptionNormalized === 'true') {
      return;
    }

    content.dataset.descriptionNormalized = 'true';
    content.classList.add('is-normalizing');

    content.querySelectorAll('script, style, meta').forEach(node => node.remove());

    content.querySelectorAll('h1, h2, h3').forEach(heading => {
      const replacement = document.createElement('h4');

      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }

      heading.replaceWith(replacement);
    });

    content.querySelectorAll('*').forEach(element => {
      Array.from(element.attributes).forEach(attribute => {
        const name = attribute.name;

        if (name === 'style' || name === 'class' || name === 'id' || name.startsWith('data-mce')) {
          element.removeAttribute(name);
        }
      });
    });

    const emptyContentSelector = 'h4, p, div, span, li, blockquote';

    const isMeaningfullyEmpty = element => {
      if (!(element instanceof Element)) {
        return false;
      }

      if (!element.matches(emptyContentSelector)) {
        return false;
      }

      if (element.querySelector('img, svg, video, iframe, table, ul, ol, form, button, hr')) {
        return false;
      }

      const text = element.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();

      if (text !== '') {
        return false;
      }

      return Array.from(element.childNodes).every(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim() === '';
        }

        return node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR';
      });
    };

    Array.from(content.querySelectorAll(emptyContentSelector)).reverse().forEach(element => {
      if (isMeaningfullyEmpty(element)) {
        element.remove();
      }
    });

    content.classList.remove('is-normalizing');
  }

  function normalizeDescriptions(root = document) {
    root.querySelectorAll('[data-product-description-content][data-product-description-normalize="true"]').forEach(normalizeDescriptionContent);
  }

  document.addEventListener('mouseover', event => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const item = event.target.closest(ITEM_SELECTOR);

    if (item && shouldActivateItem(event, item)) {
      activateItem(item);
    }
  });

  document.addEventListener('focusin', event => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const item = event.target.closest(ITEM_SELECTOR);

    if (item && shouldActivateItem(event, item)) {
      activateItem(item);
    }
  });

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const toggle = event.target.closest('[data-collection-description-toggle], [data-product-description-toggle]');

    if (!toggle) {
      return;
    }

    let details = toggle.closest('details');
    const wrapper = getDescriptionWrapper(toggle);

    if (!details && wrapper) {
      const wrapperDetails = wrapper.querySelector('details');
      if (wrapperDetails) {
        details = wrapperDetails;
      }
    }

    if (!details) {
      return;
    }

    event.preventDefault();
    details.open = !details.open;
    updateDescriptionToggle(toggle);
  });

  document.addEventListener('toggle', event => {
    if (!(event.target instanceof Element) || event.target.tagName !== 'DETAILS') {
      return;
    }

    updateDescriptionToggles(event.target);
  }, true);

  document.addEventListener('contextmenu', disableImageContextMenu, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sortEnglishMenus(), { once: true });
  } else {
    sortEnglishMenus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hoistHomepageSlideshow(), { once: true });
  } else {
    hoistHomepageSlideshow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeDescriptions(), { once: true });
  } else {
    normalizeDescriptions();
  }

  document.addEventListener('shopify:section:load', event => {
    if (event.target instanceof Element) {
      sortEnglishMenus(event.target);
      initializeAll(event.target);
      hoistHomepageSlideshow();
      normalizeDescriptions(event.target);
    }
  });

  document.addEventListener('shopify:section:load', event => {
    if (!(event.target instanceof Element)) {
      return;
    }

    event.target.querySelectorAll('details').forEach(updateDescriptionToggles);
  });
})();

(() => {
  const BUY_NOW_SELECTOR = '[data-buy-now-button]';

  async function handleBuyNowClick(button) {
    const form = button.form;

    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.setAttribute('disabled', 'disabled');
    button.setAttribute('aria-busy', 'true');

    const productForm = new FormData(form);
    const variantInput = form.querySelector('[name="id"]');

    productForm.append('sections', ['mini-cart']);
    if (variantInput instanceof HTMLInputElement && variantInput.value) {
      productForm.set('id', variantInput.value);
    }
    productForm.delete('option1');
    productForm.delete('option2');
    productForm.delete('option3');

    try {
      const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
        body: productForm,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      const responseJson = await response.json();

      if (response.ok) {
        const checkoutRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : window.themeVariables.routes.rootUrl;
        window.location.assign(`${checkoutRoot}checkout`);
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true,
        cancelable: true,
        detail: {
          status: 'error',
          error: responseJson.description || ''
        }
      }));
    } catch (error) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
        bubbles: true,
        cancelable: true,
        detail: {
          status: 'error',
          error: error instanceof Error && error.message ? error.message : ''
        }
      }));
    } finally {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    const button = target.closest(BUY_NOW_SELECTOR);

    if (!(button instanceof HTMLButtonElement)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    handleBuyNowClick(button);
  }, true);
})();

//# sourceMappingURL=/s/files/1/0043/2344/2762/t/12/assets/custom.js.map?v=1775641311
